import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";
import { AI_AGENT_ENABLED, aiAgentRoute } from "vue-app-new/plugins/AIAgent/AIAgent.plugin";

export const onsiteRoutes = [
  {
    path: "/onsite",
    redirect: "/app/onsite/mobile-search-widget",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
    },
  },
  {
    path: "/onsite",
    redirect: "/app/onsite/custom-popup",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite",
    redirect: "/app/onsite/custom-popup",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/newsletter-subscription/exit-popup-3-0",
    redirect: "/app/onsite/custom-popup",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/discover",
    redirect: "/app/onsite/custom-popup",
    meta: {
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/popups",
    name: "PageOnsitePopups",
    component: () => import("vue-app-new/pages/PageOnsitePopups/PageOnsitePopups.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/popups/:id",
    name: "PageOnsitePopup",
    component: () => import("vue-app/pages/PageOnsitePopup/PageOnsitePopup.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
    },
  },
  {
    path: "/app/onsite/banners",
    name: "PageOnsiteBanners",
    component: () => import("vue-app-new/pages/PageOnsiteBanners/PageOnsiteBanners.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/banners/:id",
    name: "PageOnsiteBanner",
    component: () => import("vue-app/pages/PageOnsiteBanner/PageOnsiteBanner.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
    },
  },
  {
    path: "/app/onsite/sliders",
    name: "PageOnsiteSliders",
    component: () => import("vue-app-new/pages/PageOnsiteSliders/PageOnsiteSliders.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/sliders/:id",
    name: "PageOnsiteSlider",
    component: () => import("vue-app/pages/PageOnsiteSlider/PageOnsiteSlider.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
    },
  },
  {
    path: "/app/onsite/mm",
    component: () => import("../pages/PageMarketingMachine.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/chat",
    component: () => import("../pages/PageOnsiteChat.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_INBOX],
      noPadding: true,
    },
  },
  {
    path: "/app/onsite/smart-recommendations",
    component: () => import("../pages/PageSmartRecommendations/PageSmartRecommendations.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
    children: [
      {
        path: "",
        component: () =>
          import("../components/SmartRecommendations/SmartRecommendationsDashboard/SmartRecommendationsDashboard.vue"),
      },
      {
        path: "edit",
        component: () =>
          import("../components/SmartRecommendations/SmartRecommendationsEdit/SmartRecommendationsEdit.vue"),
      },
    ],
  },
  {
    path: "/app/onsite/social-proofs",
    name: "PageOnsiteSocialProofs",
    component: () => import("vue-app-new/pages/PageOnsiteSocialProofs/PageOnsiteSocialProofs.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/onsite/social-proofs/:id",
    name: "PageOnsiteSocialProof",
    component: () => import("vue-app/pages/PageOnsiteSocialProof/PageOnsiteSocialProof.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
    },
  },
  {
    path: "/app/onsite/whatsapp-widget",
    name: "PageOnsiteWhatsapp",
    component: () => import("vue-app/pages/PageOnsiteWhatsapp/PageOnsiteWhatsapp.vue"),
    meta: {
      routeName: window.$_t("ONSITE"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  ...(AI_AGENT_ENABLED ? [aiAgentRoute] : []),
];
